'use strict';
export let blocklyGame;
if (window.location.href.includes('data_Simulation')) {
  blocklyGame = 10;
}
export let blockInfo = [
  [],
  [
    {
      kind: 'block',
      type: 'make_sprite',
    },
    {
      kind: 'block',
      type: 'change_behave',
    },
  ],
  [
    {
      kind: 'block',
      blockxml:
        '<block type="make_sprites">' +
        '<value name="sprites">' +
        '<block type="math_number">' +
        '<field name="NUM">1</field>' +
        '</block>' +
        '</value>' +
        '</block>',
    },
    {
      kind: 'block',
      type: 'change_behave',
    },
    {
      kind: 'block',
      type: 'check_collision',
    },
    {
      kind: 'block',
      type: 'char_select',
    },
    {
      kind: 'block',
      type: 'remove_block',
    },
  ],
  [
    {
      kind: 'block',
      blockxml:
        '<block type="make_sprites">' +
        '<value name="sprites">' +
        '<block type="math_number">' +
        '<field name="NUM">1</field>' +
        '</block>' +
        '</value>' +
        '</block>',
    },
    {
      kind: 'block',
      type: 'change_behave',
    },
    {
      kind: 'block',
      type: 'check_collision',
    },
    {
      kind: 'block',
      type: 'char_select',
    },
    {
      kind: 'block',
      type: 'remove_block',
    },
    {
      kind: 'block',
      type: 'char_select_target',
    },
  ],
  [
    {
      kind: 'block',
      blockxml:
        '<block type="make_sprites">' +
        '<value name="sprites">' +
        '<block type="math_number">' +
        '<field name="NUM">1</field>' +
        '</block>' +
        '</value>' +
        '</block>',
    },
    {
      kind: 'block',
      type: 'change_behave',
    },
    {
      kind: 'block',
      type: 'change_costume',
    },
    {
      kind: 'block',
      type: 'check_collision',
    },
    {
      kind: 'block',
      type: 'char_select_target',
    },
  ],
  [
    {
      kind: 'block',
      blockxml:
        '<block type="make_sprites">' +
        '<value name="sprites">' +
        '<block type="math_number">' +
        '<field name="NUM">1</field>' +
        '</block>' +
        '</value>' +
        '</block>',
    },
    {
      kind: 'block',
      type: 'change_behave',
    },
    {
      kind: 'block',
      type: 'check_collision',
    },
    {
      kind: 'block',
      type: 'remove_block',
    },
    {
      kind: 'block',
      type: 'char_select_target',
    },
  ],
  [
    {
      kind: 'block',
      blockxml:
        '<block type="make_sprites">' +
        '<value name="sprites">' +
        '<block type="math_number">' +
        '<field name="NUM">1</field>' +
        '</block>' +
        '</value>' +
        '</block>',
    },
    {
      kind: 'block',
      type: 'change_behave',
    },
    {
      kind: 'block',
      type: 'click_char',
    },
    {
      kind: 'block',
      type: 'remove_block',
    },
    {
      kind: 'block',
      type: 'char_select_target',
    },
  ],
  [
    {
      kind: 'block',
      blockxml:
        '<block type="make_sprites">' +
        '<value name="sprites">' +
        '<block type="math_number">' +
        '<field name="NUM">1</field>' +
        '</block>' +
        '</value>' +
        '</block>',
    },
    {
      kind: 'block',
      type: 'change_behave',
    },
    {
      kind: 'block',
      type: 'click_char',
    },
    {
      kind: 'block',
      type: 'change_costume',
    },
    {
      kind: 'block',
      type: 'char_select_target',
    },
    {
      kind: 'block',
      type: 'check_collision',
    },
  ],
];
export let instructionMsg = [
  'The penguin is hungry. Make him look for the food.',
  'Make a sprite wander all around the ground',
  'The penguin is hungry. Make him eat 5 ice creams all at once.',
  'The penguin is hungry. Make him eat 5 ice creams one by one.',
  "Make 2 penguins and 5 ice creams, make all of them wander. When penguin touches a chocolate, change the chocolate's costume to soda can",
  "Make a penguin and a rabbit. Create 10 ice creams. Make them collect the ice creams one by one. Let's see who wins!",
  'Create 10 balloons. Make them wander. And pop them by clicking on them',
  "Let's play Ice and Water. Make 2 Penguins and 5 Ice creams. Make them wander. Once the penguin and icecream collide, change ice cream's costume to stone. You can save the ice creams by clicking on them which will turn them into a sodacan",
];
export let offsetValue = 0.75;
export let gridValue = 115;
